import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { RequestServiceCodeProvider } from "presentation/store/RequestServiceCode/RequestServiceCodeProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { RequestServiceCodeMaintenance } from "presentation/view/section/RequestServiceCode/RequestServiceCodeMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const RequestServiceCodeContMain = () => {
    return <ANAInfoWrapper permission={Permission.REQUEST_SERVICE_CODE_MAINTENANCE}>
        <MessageBarWrapper>
            <RequestServiceCodeProvider>
                <GridStyles />
                <RequestServiceCodeMaintenance />
            </RequestServiceCodeProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default RequestServiceCodeContMain;